/** The ONE field-type -> icon mapping (column headers, type pickers, dialogs). Icons never replace
 * the accessible text label: they are decorative (`aria-hidden`) next to it. */
import type { ReactNode } from 'react';

import { Icons } from '@/shared/ui';

import type { FieldType } from './types';

const ICONS: Record<FieldType, () => ReactNode> = {
  text: Icons.fieldText,
  long_text: Icons.fieldLongText,
  number: Icons.fieldNumber,
  checkbox: Icons.fieldCheckbox,
  date: Icons.calendar,
  datetime: Icons.clock,
  single_select: Icons.fieldSelect,
  multi_select: Icons.fieldMultiSelect,
  status: Icons.fieldStatus,
  tags: Icons.tag,
  user: Icons.user,
};

export function fieldIcon(type: FieldType): ReactNode {
  return ICONS[type]();
}

export const FIELD_ICON_TYPES = Object.keys(ICONS) as FieldType[];
